import React from "react";
import "./timeline.css";
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import TimelineDot from '@mui/lab/TimelineDot';
import One from '../../../assets/images/one.svg';
import Two from '../../../assets/images/two.svg';
import Three from '../../../assets/images/three.svg';
import Four from '../../../assets/images/four.svg';
import Five from '../../../assets/images/five.svg';

function TimelineProfiler() {
    return (
        <div id="timelineProfiler" >
            <Timeline position="alternate">
                <TimelineItem className="timeline-item">
                    <TimelineOppositeContent
                        className="timeline-opposite-content-p"
                    >
                        <h3>Sleep apnea risk</h3>
                    </TimelineOppositeContent>
                    <TimelineSeparator>
                        <TimelineConnector sx={{ bgcolor: '#ffffff' }} />
                        <TimelineDot variant="outlined" className="timeline-dot">
                            <img src={One} alt="Profiler" className='numbers-icon' />
                        </TimelineDot>
                        <TimelineConnector className="timeline-connector" />
                    </TimelineSeparator>
                    <TimelineContent className="timeline-content" >
                        <p>Understand how your current sleep habit influences your risk towards sleep apnea </p>
                    </TimelineContent>
                </TimelineItem>
                <TimelineItem className="timeline-item">
                    <TimelineOppositeContent
                        className="timeline-content"
                    >
                        <p>Discover your resting heart rate and gain insights into its capacity for exertion</p>
                    </TimelineOppositeContent>
                    <TimelineSeparator>
                        <TimelineConnector className="timeline-connector" />
                        <TimelineDot variant="outlined" className="timeline-dot">
                            <img src={Two} alt="Profiler" className='numbers-icon' />
                        </TimelineDot>
                        <TimelineConnector className="timeline-connector" />
                    </TimelineSeparator>
                    <TimelineContent className="timeline-opposite-content-p">
                        <h3>Heart rate analysis</h3>
                    </TimelineContent>
                </TimelineItem>
                <TimelineItem className="timeline-item">
                    <TimelineOppositeContent
                        className="timeline-opposite-content-p"
                    >
                        <h3>Cardiorespiratory rhythm</h3>
                    </TimelineOppositeContent>
                    <TimelineSeparator>
                        <TimelineConnector className="timeline-connector" />
                        <TimelineDot  className="timeline-dot" variant="outlined">
                            <img src={Three} className='numbers-icon' alt="Profiler"  />
                        </TimelineDot>
                        <TimelineConnector className="timeline-connector" />
                    </TimelineSeparator>
                    <TimelineContent className="timeline-content" >
                        <p>Uncover the efficiency of your body's self-healing capabilities, determined by the coordination between your heart and lungs </p>
                    </TimelineContent>
                </TimelineItem>
                <TimelineItem className="timeline-item">
                    <TimelineOppositeContent
                        className="timeline-content"
                    >
                        <p>Heart Age offers insight into how your heart's age compares to your chronological age, providing an understanding of potential cardiac risks ​</p>
                    </TimelineOppositeContent>
                    <TimelineSeparator>
                        <TimelineConnector className="timeline-connector" />
                        <TimelineDot variant="outlined" className="timeline-dot">
                            <img src={Four} alt="Profiler" className='numbers-icon' />
                        </TimelineDot>
                        <TimelineConnector className="timeline-connector" />
                    </TimelineSeparator>
                    <TimelineContent className="timeline-opposite-content-p">
                        <h3>Heart age</h3>
                    </TimelineContent>
                </TimelineItem>
               
                <TimelineItem className="timeline-item">
                    <TimelineOppositeContent
                        className="timeline-opposite-content-p"
                    >
                        <h3>BEATS Report</h3>
                    </TimelineOppositeContent>
                    <TimelineSeparator>
                        <TimelineConnector className="timeline-connector" />
                        <TimelineDot className="timeline-dot" variant="outlined" >
                            <img alt="Profiler" src={Five}  className='numbers-icon' />
                        </TimelineDot>
                        <TimelineConnector sx={{ bgcolor: '#ffffff' }} />
                    </TimelineSeparator>
                    <TimelineContent className="timeline-content" >
                        <p>You will receive a personalized BEATS report with your heart health score​</p>
                    </TimelineContent>
                </TimelineItem>
            </Timeline>
        </div>

    );
}

export default TimelineProfiler;